export default __webpack_public_path__ + "static/i-MedicalCard Elite_e-Flyer(MV)-89022474c6fabeefbe1e7af152842430.pdf";